import { render, staticRenderFns } from "./txt.vue?vue&type=template&id=ac5b80f6&scoped=true&"
import script from "./txt.vue?vue&type=script&lang=js&"
export * from "./txt.vue?vue&type=script&lang=js&"
import style0 from "./txt.vue?vue&type=style&index=0&id=ac5b80f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac5b80f6",
  null
  
)

export default component.exports